<template>
  <div class="modal fade" id="gamanzaTournamentsModal" tabindex="-1"
    aria-labelledby="tournamentsModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content" style="background: #1a1a2e; color: white;">
        <div class="modal-header" style="border-bottom: 1px solid #333;">
          <h5 class="modal-title" id="tournamentsModalLabel">Torneos</h5>
          <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"
            aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div v-if="modalOpen" :id="widgetId" class="gamification_widget" data-type="tournaments"></div>
          <div v-else class="text-center py-4">
            <i class="fas fa-spinner fa-spin fa-2x"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gamanzaWidgetService from '@/services/gamanzaWidgetService';

export default {
  name: 'GamanzaTournaments',
  props: ['skin', 'language'],
  data() {
    return {
      modalOpen: false,
      widgetId: `gamanza-tournaments-widget-${this._uid}`,
      gameClickHandler: null
    }
  },
  mounted() {
    const modalEl = document.getElementById('gamanzaTournamentsModal');
    if (modalEl) {
      modalEl.addEventListener('shown.bs.modal', this.onModalShown);
      modalEl.addEventListener('hidden.bs.modal', this.onModalHidden);
    }

    this.gameClickHandler = (event) => this.onGameClick(event);
    document.addEventListener('click', this.gameClickHandler, true);
  },
  beforeDestroy() {
    const modalEl = document.getElementById('gamanzaTournamentsModal');
    if (modalEl) {
      modalEl.removeEventListener('shown.bs.modal', this.onModalShown);
      modalEl.removeEventListener('hidden.bs.modal', this.onModalHidden);
    }

    if (this.gameClickHandler) {
      document.removeEventListener('click', this.gameClickHandler, true);
    }
  },
  methods: {
    onGameClick(event) {
      if (!this.modalOpen) return;

      const target = event.target;
      if (!(target instanceof HTMLElement)) return;

      const gameCard = target.closest('.GamanzaGrid-root');
      if (!gameCard) return;

      const gameName = gameCard.querySelector(':scope > img')?.alt?.trim();
      if (!gameName) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      this.$root.$emit('gamanza-game-selected', gameName);
      setTimeout(() => this.closeTournamentModal(), 0);
    },
    closeTournamentModal() {
      const dialog = Array.from(document.querySelectorAll('.GamanzaDialog-root, .GamanzaModal-root'))
        .find((element) => element.querySelector('.GamanzaGrid-root'));
      const closeButton = dialog?.querySelector('[aria-label="Close"], button[class*="close"], button[class*="Close"]');

      if (closeButton) {
        closeButton.click();
      }

      const modalEl = document.getElementById('gamanzaTournamentsModal');
      if (modalEl) {
        const instance = window.bootstrap?.Modal?.getInstance(modalEl);
        instance?.hide();
      }
    },
    onModalShown() {
      this.modalOpen = true;
      this.$nextTick(() => {
        setTimeout(() => {
          gamanzaWidgetService.reloadOne(this.widgetId);
        }, 500);
      });
    },
    onModalHidden() {
      this.modalOpen = false;
      const el = document.getElementById(this.widgetId);
      if (el) {
        el.innerHTML = '';
      }
    }
  }
}
</script>

<style scoped>
.gamification_widget {
  min-height: 400px;
}
</style>
